/**
 * Epilekton — sync the PDP buy button's price span with the selected variant.
 *
 * The PDP uses the custom Epilekton split-button (see sections/main-product.liquid):
 *   <button id="ProductSubmitButton-{section.id}" class="epi-buy-button__cta">
 *     <span class="epi-buy-button__cta-label">Add to cart</span>
 *     <span class="epi-buy-button__cta-price" data-product-price>€X.XX</span>
 *   </button>
 *
 * Dawn's product-info.js re-renders the price block (#price-{sectionId}) on
 * variant change but leaves the button's price span untouched. We observe the
 * price block and mirror its visible money string into [data-product-price],
 * and also strip the price span when the button is disabled (sold out /
 * unavailable) so Dawn's label-only copy is preserved.
 */
(function () {
  'use strict';

  function readDisplayedPrice(priceEl) {
    if (!priceEl) return '';
    var sale = priceEl.querySelector('.price-item--sale:not(.price-item--regular)');
    if (sale && sale.textContent.trim()) return sale.textContent.trim();
    var regular = priceEl.querySelector('.price-item--regular');
    if (regular && regular.textContent.trim()) return regular.textContent.trim();
    var any = priceEl.querySelector('.price-item');
    return any ? any.textContent.trim() : '';
  }

  function syncButton(button, priceEl) {
    var priceSpan = button.querySelector('[data-product-price]');

    if (button.hasAttribute('disabled')) {
      if (priceSpan) priceSpan.textContent = '';
      return;
    }

    var current = readDisplayedPrice(priceEl);
    if (!current) return;

    if (priceSpan) {
      if (priceSpan.textContent.trim() !== current) priceSpan.textContent = current;
    } else {
      // Span was stripped (e.g. by an earlier sold-out render) — rebuild it.
      var span = document.createElement('span');
      span.className = 'epi-buy-button__cta-price';
      span.setAttribute('data-product-price', '');
      span.textContent = current;
      button.appendChild(span);
    }
  }

  function bindProductInfo(productInfo) {
    var sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
    if (!sectionId) return;

    var button = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
    var priceEl = productInfo.querySelector('#price-' + sectionId);
    if (!button || !priceEl) return;

    var pending = false;
    var schedule = function () {
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () {
        pending = false;
        syncButton(button, priceEl);
      });
    };

    new MutationObserver(schedule).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    new MutationObserver(schedule).observe(button, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    syncButton(button, priceEl);
  }

  function init() {
    document.querySelectorAll('product-info').forEach(bindProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
